import React from "react"
import { forwardRef } from "@design-system/styled-system"
import { Grid } from "./Grid"
import { SimpleGridProps } from "./types"

function toPx(n: string | number) {
  return typeof n === "number" ? `${n}px` : n
}

function widthToColumns(width?: string | number) {
  return width == null
    ? undefined
    : `repeat(auto-fit, minmax(${toPx(width)}, 1fr))`
}

function countToColumns(count?: number) {
  return count == null ? undefined : `repeat(${count}, 1fr)`
}

export const SimpleGrid = forwardRef<SimpleGridProps, "div">((props, ref) => {
  const { columns, spacingX, spacingY, spacing, minChildWidth, ...rest } = props

  const templateColumns = minChildWidth
    ? widthToColumns(minChildWidth)
    : countToColumns(columns)

  return (
    <Grid
      ref={ref}
      gap={spacing}
      columnGap={spacingX}
      rowGap={spacingY}
      templateColumns={templateColumns}
      {...rest}
    />
  )
})

SimpleGrid.displayName = "SimpleGrid"
